import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { MatDivider } from "@angular/material/divider";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { PurchaseOrderInvoiceViewModel } from "@tylertech/tyler-api-types";
import { InvoiceHistoryComponent } from "./poInvoiceHistory.component";

/**
 * @deprecated I think this has been replaced by a MetadataAction in the backend.
 * TODO - Confirm and Remove.
 */
export interface InvoiceDialogData
{
    readonly invoices: PurchaseOrderInvoiceViewModel[];
}

/**
 * @deprecated I think this has been replaced by a MetadataAction in the backend.
 * TODO - Confirm and Remove.
 */
@Component({
    selector: "invoice-dialog-component",
    templateUrl: "./poInvoiceDialog.tmpl.html",
    imports: [
        CdkScrollable,
        LayoutAlignDirective,
        LayoutDirective,
        InvoiceHistoryComponent,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatDivider,
    ]
})
export class InvoiceDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<InvoiceDialogComponent>>(MatDialogRef);
    private readonly data = inject<InvoiceDialogData>(MAT_DIALOG_DATA);


    get invoices(): PurchaseOrderInvoiceViewModel[]
    {
        return this.data.invoices;
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
